import React, { useState } from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';
import { HANUMAN_COLORS } from './hanumanColors';

const ToggleLink = styled.button`
  background: none;
  border: none;
  color: ${p => p.theme.colors.text.muted};
  font-size: 13px;
  cursor: pointer;
  padding: ${p => p.theme.spacing[2]}px 0;
  text-decoration: underline;
  margin-top: ${p => p.theme.spacing[5]}px;
`;

const Box = styled.div`
  max-width: 600px;
  margin: ${p => p.theme.spacing[3]}px auto 0;
  padding: ${p => p.theme.spacing[4]}px;
  background: #FFFBF0;
  border: 1px solid ${HANUMAN_COLORS.cellBorder};
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.7;
  color: ${p => p.theme.colors.text.secondary};
  text-align: left;
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};

  p { margin: 0 0 ${p => p.theme.spacing[2]}px; }
  p:last-child { margin-bottom: 0; }
`;

const Title = styled.h3`
  font-size: 15px;
  color: ${HANUMAN_COLORS.primaryDark};
  margin: 0 0 ${p => p.theme.spacing[2]}px;
  font-weight: 600;
`;

const AboutHanuman = ({ lang }) => {
  const t = useLocale(lang, 'hanumanPrashnavali');
  const [expanded, setExpanded] = useState(false);

  return (
    <div>
      <ToggleLink onClick={() => setExpanded(!expanded)} aria-expanded={expanded}>
        {expanded ? (t.aboutToggleOpen || 'Close') : (t.aboutToggleClosed || 'What is Hanuman Prashnavali?')}
      </ToggleLink>
      {expanded && (
        <Box>
          <Title>{t.aboutToggleClosed || 'What is Hanuman Prashnavali?'}</Title>
          <p>{t.aboutOrigin || 'This tool is based on the Hanuman Chalisa tradition composed by Sant Tulsidas.'}</p>
          <p>{t.aboutHow || '49 cells arranged in a 7×7 grid. Each cell starts a 7-letter path that reveals a verse from the Chalisa.'}</p>
          <p>{t.aboutIntention || "Hold your challenge in mind, select a cell, and receive Hanuman's counsel."}</p>
          <p>{t.aboutCulture || 'Tuesdays and Saturdays are traditionally dedicated to Hanuman. Devotees seek strength for challenges on these days.'}</p>
        </Box>
      )}
    </div>
  );
};

export default AboutHanuman;
